import { graphql } from 'gatsby';
import * as React from 'react';
import { useMonthRange } from '../hooks/use-month-range';
import { ServiceSchedule } from '../shared-types';
import { DateField } from './date-field';
import { useLocalize } from './localize-context';

type ScheduleCheckerProps = {
  schedules: ServiceSchedule[];
};

export const ScheduleChecker = (props: ScheduleCheckerProps) => {
  const localize = useLocalize();
  const { lastMonthDate, currentDateRef, currentMonthStartRef } = useMonthRange(
    props.schedules
  );
  const allowedDates = React.useMemo(
    () =>
      props.schedules
        ? props.schedules.map(schedule => schedule.date)
        : undefined,
    [props.schedules]
  );
  const [date, setDate] = React.useState('');
  const availableTimes = React.useMemo(() => {
    if (!date) {
      return null;
    }
    return props.schedules
      .filter(schedule => schedule.date === date)
      .map(schedule => schedule.time)[0];
  }, [date, props.schedules]);

  return (
    <div className="p-4">
      <DateField
        label={localize('Date')}
        value={date}
        onChangeValue={setDate}
        fromMonth={currentMonthStartRef.current}
        toMonth={lastMonthDate}
        allowedDates={allowedDates}
        minDate={currentDateRef.current}
        id="schedule-checker-date"
      />
      <div className="my-4">
        <label>{localize('Departure Time')}</label>
        <output htmlFor="schedule-checker-date" className="block text-5xl">
          {availableTimes ? (
            availableTimes.map((time, index) => <div key={index}>{time}</div>)
          ) : (
            <p className="text-xl">
              {localize('Choose a date to see departure time')}
            </p>
          )}
        </output>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment ScheduleChecker on ScheduleYaml {
    date(formatString: "YYYY-MM-DD")
    time
  }
`;
